class InvalidSwitchValueError extends Error {
	constructor(message: string) {
		super(message);
		this.name = "InvalidSwitchValueError";
	}
}

export function safeExhaustiveSwitch<T>(fn: () => T, fallback: (error: Error) => T): T {
	try {
		return fn();
	} catch (error) {
		if (error instanceof InvalidSwitchValueError) {
			return fallback(error);
		}

		throw error;
	}
}

export function exhaustiveCheck(value: never): never {
	throw new InvalidSwitchValueError(`Invalid runtime switch value : ${value}`);
}
